import { useCallback, useMemo } from 'react';

import { getInsight, mapApiInsightDetailToUi } from '../../../services/insights.js';
import { useItemDetail } from './useItemDetail.js';

/**
 * One insight's detail, for the slide-out (CT-5716). The race guard, the 404 /
 * 403 outcomes and the quiet `refresh` are `useItemDetail`'s.
 */
export function useInsight({ entityType, entityId, insightId } = {}) {
  // The service is read at call time, not captured, so a test can spy on it.
  const load = useCallback(
    () => getInsight({ entityType, entityId, insightId }),
    [entityType, entityId, insightId],
  );
  const { item, loading, error, notFound, accessDenied, refetch, refresh } = useItemDetail({
    id: insightId,
    load,
    map: mapApiInsightDetailToUi,
    errorMessage: 'Failed to load the insight',
  });

  return useMemo(
    () => ({ insight: item, loading, error, notFound, accessDenied, refetch, refresh }),
    [item, loading, error, notFound, accessDenied, refetch, refresh],
  );
}

export default useInsight;
